import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../utils';
import {
  getCompanyCodeTranslation,
  GetCompanyCodeTranslationQueryVariables,
  GetCompanyCodeTranslationQuery,
  CreateCompanyCodeTranslationArrayMutation,
  CreateCompanyCodeTranslationArrayInput,
  createCompanyCodeTranslationArray,
} from '../../../graphql';
import { GetCompanyCodeTranslationQueryResponse } from '../../../types/graphql';

export const tcsTdsApi = createApi({
  reducerPath: 'listAccountMasterv4',
  baseQuery: baseQuery,
  tagTypes: ['tdstcs'],
  endpoints: (builder) => ({
    listTcsTds: builder.query<GetCompanyCodeTranslationQueryResponse, GetCompanyCodeTranslationQueryVariables>({
      query: () => ({ body: getCompanyCodeTranslation }),
      keepUnusedDataFor: 300,
      transformResponse: (response: GetCompanyCodeTranslationQuery) => response?.getCompanyCodeTranslation || [],
      providesTags: ['tdstcs'],
    }),
    createAccountMaster: builder.mutation<CreateCompanyCodeTranslationArrayMutation, CreateCompanyCodeTranslationArrayInput>({
      query: (variables) => ({ body: createCompanyCodeTranslationArray, variables }),
      invalidatesTags: ['tdstcs'],
    }),
    
  }),
});

export const { useCreateAccountMasterMutation, useLazyListTcsTdsQuery, useListTcsTdsQuery, usePrefetch } = tcsTdsApi;
